import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { headersToFooters } from '@views/reports/elements/ReportsPdfDocument/elements/ReportsPdfTable/utils/headersToFooter'

import { mapTrialBalanceBalances } from '../../../../utils/balanceMappers'
import { buildTableData } from '../../../../utils/buildTableData'
import { getHeaderRow, getRowData } from '../utils/trialBalanceCsvFormatters'
import { useTrialBalanceData } from './useTrialBalanceData'

export const useTrialBalanceSpreadSheetExportData = () => {
  const { t } = useTranslation()
  const { reportData, allExpandableIds } = useTrialBalanceData()

  const expandedRows = useMemo(
    () => allExpandableIds?.reduce((acc, id) => ({ ...acc, [id]: true }), {}) ?? {},
    [allExpandableIds],
  )

  const tableData = buildTableData(reportData, expandedRows, [], mapTrialBalanceBalances)
  const sortedData = headersToFooters(tableData)

  const spreadSheetData = useMemo(() => [getHeaderRow(t), ...sortedData.map((row) => getRowData(row))], [sortedData, t])

  return { spreadSheetData }
}
